export enum ApplicationToken {
  PARKIZA = 'parkiza-token',
  WAYIN = 'wayin-token',
  VISITORS = 'visitors-token',
  ISSUES = 'issues-token',
}
